import { PlusOutlined } from "@ant-design/icons";
import { ForkKnifeIcon } from "../ForkKnifeIcon";
import { useTranslation } from "react-i18next";

/** Празният екран „Обедно меню" — още няма нито едно меню: иконка, изречение и „Ново". */
export const LunchMenusEmpty = ({ onNew }: { onNew: () => void }) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-1 items-center justify-center px-6 py-10">
      <div className="flex max-w-[420px] flex-col items-center gap-3 text-center">
        <span className="mb-1 grid h-16 w-16 place-items-center rounded-[18px] bg-pos-ready-bg text-[28px] text-pos-accent">
          <ForkKnifeIcon />
        </span>
        <h2 className="m-0 text-xl font-extrabold leading-[1.2] text-pos-ink">
          {t("lunchMenu.emptyTitle")}
        </h2>
        <p className="m-0 text-sm leading-[1.55] text-pos-soft">
          {t("lunchMenu.emptyText")}
        </p>
        <button
          type="button"
          onClick={onNew}
          className="mt-2 inline-flex h-[52px] cursor-pointer items-center justify-center gap-2 rounded-[13px] border-0 bg-pos-accent px-7 text-[15px] font-bold text-white transition-colors hover:bg-pos-accent-ink"
        >
          <PlusOutlined />
          {t("lunchMenu.newMenu")}
        </button>
      </div>
    </div>
  );
};
